
exports.NODE_ENV = 'production';
exports.TIMESTAMP = '1788503689670';
exports.BUILD_TIMESTAMP = '1788503689670';
